import React, { memo } from "react";

const Image = ({ src, className, alt = "", height, ...prop }) => {
  return (
    <img src={src} alt={alt} className={className} height={height} {...prop} />
  );
};

export default memo(Image);
